import React from "react";
import { Typography, Button, Container, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import FXCMTrans from "../common/FXCMTrans";
import PropTypes from 'prop-types';
import { unsuccessfulWarning } from "../../constants/ImageConstants";
import "./style.scss";

const UserMessage1 = (props) => {
	const { t: getLabel } = useTranslation();
	const { isEmailExist, image, title, description, handleClick, buttonText,isEmailExistDescription,isEmailExistTitle } = props;

	return (
		<Box align="center" className="password-Box">
			<Container
				maxWidth={false}
				sx={{ maxWidth: "600px", wordWrap: "break-word" }}
			>
				<div className="password-box">
					{isEmailExist ? (<img src={image} alt="mailImg" className="cardIcon" />):<><br/><br/><img src={unsuccessfulWarning} alt="mailImg" className="cardIcon" /></>}
					
					<Typography className="heading-1" sx={{ mt: "20px" }}>
							<FXCMTrans
								defaults={isEmailExist? getLabel(title):getLabel(isEmailExistTitle)}
							/>
					</Typography>
					
					<Typography className="subtext-cards" sx={{ mt: "20px", maxWidth: "448px", }}>
						{isEmailExist ? getLabel(description):getLabel(isEmailExistDescription)}
					</Typography>
					<Button
						variant="contained"
						color="primary"
						sx={{ mt: 3 }}
						onClick={handleClick}
					>
						{getLabel(buttonText)}
					</Button>
				</div>
			</Container>
		</Box>
	);
};

UserMessage1.propTypes = {
	isEmailExist: PropTypes.bool,
	isEmailExistDescription:PropTypes.string,
	isEmailExistTitle:PropTypes.string,
	image: PropTypes.string,
	title: PropTypes.string,
	description: PropTypes.string,
	buttonText: PropTypes.string,
	handleClick: PropTypes.func
}

export default UserMessage1;